import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from 'projects/shared/lib/components/shared/breadcrumb/breadcrumb.models';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';

import { BreadcrumbComponent } from '../../../breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-widget-breadcrumb',
    imports: [BreadcrumbComponent],
    templateUrl: './widget-breadcrumb.component.html',
    styleUrls: ['./widget-breadcrumb-base.component.scss']
})
export class WidgetBreadcrumbBaseComponent extends WidgetBaseComponent implements OnInit {
  public breadcrumbList: Breadcrumb[] | undefined;

  public ngOnInit(): void {
    this.breadcrumbList = [];
  }
}
